import { compose, lifecycle, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import { setRenderBVReviews } from 'components/common/hoc/withBazaarVoiceInlineRatings/actions'
import { getRenderBVReviews } from 'components/common/hoc/withBazaarVoiceInlineRatings/selectors'
import BazaarVoiceReviewsSummary from './BazaarVoiceReviewsSummary'
import { ERROR_SCRIPT_NOT_LOADED, REVIEWS_SUMMARY_CONTAINER_PREFIX } from '../../constants'

const withCommonVariables = withProps(
  () => ({ productReviewsSummaryContainer: REVIEWS_SUMMARY_CONTAINER_PREFIX })
)

const mapStateToProps = state => ({ renderBVReviews: getRenderBVReviews(state) })

const withGenerateBVReviewsSummary = withHandlers({
  generateBVReviewsSummary: ({ setRenderBVReviews, renderBVReviews }) => productId => {
    const intervalId = setInterval(() => {
      try {
        /* global $BV */
        if ($BV && $BV.ui) {
          clearInterval(intervalId)
          $BV.ui('rr', 'show_reviews', {
            summaryContainerDiv: REVIEWS_SUMMARY_CONTAINER_PREFIX,
            productId
          })
          !renderBVReviews && setRenderBVReviews(true)
        }
      } catch (err) {
        console.log(ERROR_SCRIPT_NOT_LOADED, err)
        typeof renderBVReviews === 'boolean' ? setRenderBVReviews(null) : setRenderBVReviews(false)
      }
    }, 1000)
  }
})

const withLaunchBazaarVoiceScript = lifecycle({
  componentDidMount() {
    const { renderBVReviews, generateBVReviewsSummary, productId } = this.props
    !renderBVReviews && generateBVReviewsSummary(productId)
  },
  componentDidUpdate({ productId: prevProductId }) {
    const { productId, renderBVReviews, generateBVReviewsSummary } = this.props
    if (!renderBVReviews) {
      generateBVReviewsSummary(productId)
    } else if (renderBVReviews && productId && prevProductId !== productId) {
      generateBVReviewsSummary(productId)
    }
  },
  componentWillUnmount() {
    const { renderBVReviews, setRenderBVReviews } = this.props
    renderBVReviews && setRenderBVReviews(false)
  }
})

export default compose(
  withCommonVariables,
  connect(mapStateToProps, { setRenderBVReviews }),
  withGenerateBVReviewsSummary,
  withLaunchBazaarVoiceScript
)(BazaarVoiceReviewsSummary)
